const createNoopStorage = () => ({
  getItem() {
    return Promise.resolve(null);
  },
  setItem() {
    return Promise.resolve();
  },
  removeItem() {
    return Promise.resolve();
  }
});

const getStorage = () => {
  if (typeof window === 'undefined') return createNoopStorage();
  // eslint-disable-next-line @typescript-eslint/no-var-requires, import/no-extraneous-dependencies, global-require
  const storage = require('redux-persist/lib/storage').default;
  return storage;
};

export const persistStorage = getStorage();
